// src/components/OrderLabelModal.js

import React from 'react';
import { OrderLabel } from './OrderLabel';

export const OrderLabelModal = ({ order, onClose }) => {

  const printLabel = () => {
    const labelElement = document.getElementById("print-label");
    if (!labelElement) return;

    const labelClone = labelElement.cloneNode(true);

    const printWindow = window.open("", "_blank");
    if (!printWindow) return;

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Order Label</title>
          <style>
            @page {
              size: 60mm 20mm;
              margin: 0;
            }

            * { box-sizing: border-box; }

            html, body {
              width: 60mm;
              height: 20mm;
              margin: 0;
              padding: 0;
              background: white;
              overflow: hidden;
            }

            #print-page {
              width: 60mm;
              height: 20mm;
              margin: 0;
              padding: 0;
              background: white;
              overflow: hidden;
            }

            #print-page #print-label {
              width: 60mm !important;
              height: 20mm !important;
              display: flex !important;
              flex-direction: column !important;
              justify-content: space-between !important;
              margin: 0 !important;
              padding: 1.5mm 2mm !important;
              box-sizing: border-box !important;
              overflow: hidden !important;
              
            }
          </style>
        </head>
        <body>
          <div id="print-page">
            ${labelClone.outerHTML}
          </div>
          <script>
            window.onload = function () {
              setTimeout(function () {
                window.focus();
                window.print();
              }, 300);
              window.onafterprint = function () {
                window.close();
              };
            };
          </script>
        </body>
      </html>
    `);

    printWindow.document.close();
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0, 0, 0, 0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "500px",
          backgroundColor: "white",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          borderRadius: "8px",
          padding: "20px",
        }}
        onClick={(e) => e.stopPropagation()}
      >

        <h3 style={{ marginBottom: "20px", color: "#004aad" }}>
          Order Label (60 × 20 mm)
        </h3>

        <OrderLabel order={order} />

        <div style={{ display: "flex", gap: "10px", marginTop: "30px" }}>
          <button
            onClick={printLabel}
            style={{
              padding: "8px 12px",
              fontSize: "14px",
              fontWeight: "bold",
              color: "white",
              backgroundColor: "#007BFF",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              width: "150px",
            }}
          >
            Print Label
          </button>
          <button
            onClick={onClose}
            style={{
              padding: "8px 12px",
              fontSize: "14px",
              fontWeight: "bold",
              color: "white",
              backgroundColor: "#6c757d",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              width: "150px",
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};